import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { FooterBrand } from './FooterBrand';
import { FooterCopyright } from './FooterCopyright';
import { FooterLink } from './FooterLink';
import { FooterLinkGroup } from './FooterLinkGroup';
import { FooterIcon } from './FooterIcon';
const FooterComponent = ({ children, className }) => {
    return (_jsx("footer", { className: classNames('w-full rounded-lg bg-white p-4 shadow dark:bg-gray-800 md:flex md:items-center md:justify-between md:p-6', className), children: children }));
};
FooterComponent.displayName = 'Footer';
FooterCopyright.displayName = 'Footer.Copyright';
FooterLink.displayName = 'Footer.Link';
FooterBrand.displayName = 'Footer.Brand';
FooterLinkGroup.displayName = 'Footer.LinkGroup';
FooterIcon.displayName = 'Footer.Icon';
export const Footer = Object.assign(FooterComponent, {
    Copyright: FooterCopyright,
    Link: FooterLink,
    LinkGroup: FooterLinkGroup,
    Brand: FooterBrand,
    Icon: FooterIcon,
});
